import * as yup from "yup";
import { TFunction } from "i18next";

export type TAddCourseForm = {
  course: number;
};

export const addCourseValidationSchema = (t: TFunction) =>
  yup.object().shape({
    course: yup.number().nullable().required(t("validation.required")),
  });
